module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabriels_BW_Web-p-1080-b0a2aefef8660d687752c6374d9b7a49.jpg";